'use strict';
module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};



//////////////////
// WEBPACK FOOTER
// E:/Websites/eco-pest-group/app/public/wp-content/themes/pestaid-v2-4/node_modules/core-js/internals/perform.js
// module id = 91
// module chunks = 0